import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class ApprovalButtonsHeaderController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    levelCount: number;

    static $inject = [];
}

export const wtApprovalButtonsHeader: ComponentDefinition = {
    componentId: 'wtApprovalButtonsHeader',
    controller: ApprovalButtonsHeaderController,
    template: require('./approvalButtonsHeader.component.html'),
    controllerAs: 'vm',
    bindings: {
        levelCount: '<'
    }
};